/** @file Shows the AI view filtered to one actor (the Activity badge link, spec §9). */
import { createT } from '@pose2d/i18n/createT';
import type { DockTarget } from '../../frame/applyLayout';
import { openPanel } from '../../frame/openPanel';
import { catalogs } from '../../shell/i18n/catalogs';
import { settingsStore } from '../../stores/settingsStore';
import { panel } from './Panel';
import { aiViewStore } from './aiViewStore';

/** Sets the filter and activates the `aiView` panel, re-adding its tab first when the user closed it. */
export function openAiView(dock: DockTarget, actor: string): void {
  aiViewStore.setState({ actor, open: null });
  openPanel(dock, panel, createT(catalogs, settingsStore.getState().lang));
}
